import type { FaireThemeEntity } from "../../entity_types/theme";

export const water_resistant_gold_essentials: FaireThemeEntity = {
  token: "water-resistant-gold-essentials",
  type: "theme",
  name: "Water-Resistant Gold Essentials",
  description: "Upgrade your jewelry display with 18K gold-plated pieces designed to last. These non-tarnish, water-resistant staples are perfect for low-maintenance style.",
  teaser: "As a beauty lounge and boutique, your customers likely value high-quality, durable accessories that maintain their luster during daily routines. These 18K gold-plated items offer the luxury feel your clientele expects.",
  detail: "All five products you recently engaged with from Flânerie by MAIQ are specifically marketed as non-tarnish, hypoallergenic, and water-resistant, indicating a strong preference for these durable material qualities.",
  bgColor: "#D4C4B0",
  tileBgColor: "#39676b",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_ut3tbs6mrw",
    "p_nrg5hxcuy3",
    "p_mfzddjcp7d",
    "p_s7mxah3gtv",
    "p_wtd92k72m5",
    "p_85zuvdfqvw",
    "p_pdvfyz7trd",
    "p_dvc55z5255",
    "p_449vg23vfm",
    "p_my2xj2rcvg",
    "p_pqf2f49nzz",
    "p_4yrfvdanaw",
    "p_dzsbf55zgn",
    "p_ar6ja253qt",
    "p_r2t6rskrt8",
    "p_3tuhu2tp5g",
    "p_xh2ydbj634",
    "p_en52fkxk94",
    "p_5acjffyjzf",
    "p_jhcrb92fnq",
    "p_94p6kms3ue",
    "p_uy48enz994",
    "p_cghmrnd49u",
    "p_cmmmbhr9mb",
    "p_wdbadfh7jt",
    "p_v4yrvbjn34",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
